export enum CourseCategory {
  CARDIO = 'cardio',
  STRETCHING = 'stretching',
}
